jQuery(document).ready(function() {
    jQuery('.accordion-button').click(function(e) {
        e.preventDefault();

        let $this = jQuery(this);

        if ($this.hasClass('collapsed')) {
            $this.parents('.accordion-item').removeClass('active');
        } else {
            $this.parents('.accordion-item').siblings().removeClass('active');
            $this.parents('.accordion-item').addClass('active');
        }
    });
});

jQuery(window).on('scroll', function() {
    if (jQuery(window).scrollTop() >= 100) {
        jQuery('.header-part').addClass('sticky');
    } else {
        jQuery('.header-part').removeClass('sticky');
    }
});

// Move to top
function moveTo(id) {
    var nav_height = 60;

    if (jQuery(window).width() > 600) {
        nav_height = 100;
    }

    jQuery('html,body').animate({
        scrollTop: jQuery(id).offset().top - nav_height + 1
    }, 100);
    return false;
}

document.addEventListener('DOMContentLoaded', function() {
    // Get the header element
    let header = document.querySelector('header');

    // Get the height of the header
    let headerHeight = header.offsetHeight;

    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            // Get the target element that the anchor link points to
            let target = document.querySelector(this.getAttribute('href'));
            if (target) {
                let targetPosition = target.getBoundingClientRect().top - headerHeight + window.pageYOffset;

                window.scrollTo(0, targetPosition);

                // Smooth scroll to the target position with custom duration
                //smoothScrollTo(targetPosition, 10000); // Duration in milliseconds
            }
        });
    });

    function smoothScrollTo(target, duration) {
        let start = window.pageYOffset;
        let distance = target - start;
        let startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            let timeElapsed = currentTime - startTime;
            let run = ease(timeElapsed, start, distance, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        }

        function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    }
});
